const FACET_COUNT_UNITS = [
    { threshold: 1_000_000_000, suffix: "B" },
    { threshold: 1_000_000, suffix: "M" },
    { threshold: 1_000, suffix: "K" },
] as const;

export const formatFacetCount = (count: number): string => {
    const value = Math.trunc(Math.abs(count));

    for (let index = 0; index < FACET_COUNT_UNITS.length; index += 1) {
        const unit = FACET_COUNT_UNITS[index];
        if (value < unit.threshold) continue;

        const scaled = value / unit.threshold;
        const decimals =
            scaled >= 100 ? 0
            : scaled >= 10 ? 1
            : 2;
        const rounded = Number(scaled.toFixed(decimals));
        const overflowsIntoBiggerUnit = rounded >= 1000 && index > 0;
        const displayUnit = overflowsIntoBiggerUnit ? FACET_COUNT_UNITS[index - 1] : unit;
        const displayValue =
            overflowsIntoBiggerUnit ? rounded / 1000
            : index === 0 ? Math.min(rounded, 999)
            : rounded;

        return `${count < 0 ? "-" : ""}${displayValue}${displayUnit.suffix}`;
    }

    return `${count < 0 ? "-" : ""}${value}`;
};
